"use strict";
var typeahead_match_class_1 = require('./typeahead/typeahead-match.class');
exports.TypeaheadMatch = typeahead_match_class_1.TypeaheadMatch;
var typeahead_options_class_1 = require('./typeahead/typeahead-options.class');
exports.TypeaheadOptions = typeahead_options_class_1.TypeaheadOptions;
var typeahead_utils_1 = require('./typeahead/typeahead-utils');
exports.TypeaheadUtils = typeahead_utils_1.TypeaheadUtils;
var typeahead_container_component_1 = require('./typeahead/typeahead-container.component');
exports.TypeaheadContainerComponent = typeahead_container_component_1.TypeaheadContainerComponent;
var typeahead_directive_1 = require('./typeahead/typeahead.directive');
exports.TypeaheadDirective = typeahead_directive_1.TypeaheadDirective;
var typeahead_module_1 = require('./typeahead/typeahead.module');
exports.TypeaheadModule = typeahead_module_1.TypeaheadModule;



//////////////////
// WEBPACK FOOTER
// ./~/ng2-bootstrap/components/typeahead.js
// module id = 1009
// module chunks = 1